export const CONTACT_EMAIL = "hola@casvisoftware.com";

// Los textos de cada sección viven en Constants/i18n.js
export const NAV_ITEMS = [
  { id: "nosotros", to: "/#nosotros" },
  { id: "servicios", to: "/#servicios" },
  { id: "proyectos", to: "/#proyectos" },
  { id: "apps", to: "/apps" },
  { id: "contacto", to: "/#contacto" },
];

// Secciones de la página de inicio que se marcan como activas al hacer scroll
export const HOME_SECTION_IDS = ["nosotros", "servicios", "proyectos", "contacto"];

export const SERVICE_ICONS = ["📱", "💻", "☁️", "✨"];
